import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface DeleteMenuItemMutation {
  deleteMenuItem: boolean
}

export interface DeleteMenuItemVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DELETE_MENU_ITEM = gql`
  mutation deleteMenuItem($id: ID!) {
    deleteMenuItem(id: $id)
  }
`

export const useDeleteMenuItem = () =>
  useMutation<DeleteMenuItemMutation, DeleteMenuItemVariables>(GQL_MUTATION_DELETE_MENU_ITEM)
